// // data/servicesData.js
// import styleCompanys from '../css/backgrounds/comCreated.module.css';
// import stylePrem from '../css/backgrounds/primResidency.module.css';
// import styleMark from '../css/backgrounds/markService.module.css';
// import styleAcc from '../css/backgrounds/accServices.module.css';
// import styleProg from '../css/backgrounds/programming.module.css';

// export const servicesData = [
//   // المجموعة 1
//   {
//     id: 1,
//     services: [
//       {
//         id: 0,
//         name: "خدمة التدريب والتأهيل",
//         className: "training",
//         detailsLink: "/services/TrainQualif",
//         whatsappLink: "https://wa.me/+966561103887?text= السلام عليكم. اريد استفسر عن خدمة التدريب والتاهيل",
//         detailsType: "link" // link أو text
//       },
//       {
//         id: 1,
//         name: "خدمات الاستشارات الهندسية",
//         className: "eng-consultation",
//         detailsLink: "/services",
//         whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم. اريد استفسر عن خدمة هندسية",
//         detailsType: "link"
//       }
//     ]
//   },
//   // المجموعة 2
//   {
//     id: 2,
//     services: [
//       {
//         id: 2,
//         name: "خدمات التأمين الصحي الشامل",
//         className: "health-Insurance",
//         detailsLink: "/services/medicalservices",
//         whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم. عندس استفسار عن خدمات التامين الصحي الشامل",
//         detailsType: "span-link"
//       },
//       {
//         id: 3,
//         name: "خدمات سابر",
//         className: "saber-service",
//         detailsLink: "/services/saberservices",
//         whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم. عندس استفسار عن خدمات سابر",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 3
//   {
//     id: 3,
//     services: [
//       {
//         id: 4,
//         name: "خدمات وزارة الداخلية",
//         className: "ministry-interior",
//         detailsLink: "#",
//         whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم. اريد استفسر عن خدمات وازارة الداخلية",
//         detailsType: "span-text",
//         detailsText: "التفاصيل"
//       },
//       {
//         id: 5,
//         name: "خدمات منصة ناجز",
//         className: "najiz-service",
//         detailsLink: "/services/najizServices",
//         whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم. اريد استفسر عن خدمات منصة ناجز",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 4
//   {
//     id: 4,
//     services: [
//       {
//         id: 6,
//         name: "خدمات منصة مدد",
//         className: "madad-service",
//         detailsLink: "/services/madad",
//         whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم اريد استفسر عن خدمات منصة مدد",
//         detailsType: "span-link"
//       },
//       {
//         id: 7,
//         name: "خدمات الدفاع المدني",
//         className: "civil-defense",
//         detailsLink: "/services/civilservices",
//         whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم. لدي استفسار عن خدمات الدفاع المدني",
//         detailsType: "span-link",
//         detailsText: "التفاصل"
//       }
//     ]
//   },
//   // المجموعة 5 - التراخيص
//   {
//     id: 5,
//     services: [
//       {
//         id: 8,
//         name: "الترخيص المهني",
//         className: `${styleCompanys.back1} service-item`,
//         detailsLink: "/services/professionallicense",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص مهني",
//         detailsType: "span-link"
//       },
//       {
//         id: 9,
//         name: "الترخيص الزراعي",
//         className: `${styleCompanys.back2} service-item`,
//         detailsLink: "/services/agriculturallicense",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص زراعي",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 6
//   {
//     id: 6,
//     services: [
//       {
//         id: 10,
//         name: "ترخيص تجاري اجنبي",
//         className: `${styleCompanys.back3} service-item`,
//         detailsLink: "/services/forecommlice",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص تجاري اجنبي",
//         detailsType: "span-link"
//       },
//       {
//         id: 11,
//         name: "ترخيص تجاري بشريك سعودي",
//         className: `${styleCompanys.back4} service-item`,
//         detailsLink: "/services/coiLissauPar",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص تجاري بشريك سعودي",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 7
//   {
//     id: 7,
//     services: [
//       {
//         id: 12,
//         name: "الترخيص المهني بشريك سعودي",
//         className: `${styleCompanys.back5} service-item`,
//         detailsLink: "/services/proflicesapartner",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص مهني بشريك سعودي",
//         detailsType: "span-link"
//       },
//       {
//         id: 13,
//         name: "ترخيص أنشطة النقل",
//         className: `${styleCompanys.back6} service-item`,
//         detailsLink: "/services/transactivlice",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص نشاط نقل",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 8
//   {
//     id: 8,
//     services: [
//       {
//         id: 14,
//         name: "الترخيص العقاري",
//         className: `${styleCompanys.back7} service-item`,
//         detailsLink: "/services/prolic",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص عقاري",
//         detailsType: "span-link"
//       },
//       {
//         id: 15,
//         name: "ترخيص صناعي",
//         className: `${styleCompanys.back8} service-item`,
//         detailsLink: "/services/indlic",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص صناعي",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 9 - الإقامات
//   {
//     id: 9,
//     services: [
//       {
//         id: 16,
//         name: "إقامة مستثمر أعمال",
//         className: `${stylePrem.back1} service-item`,
//         detailsLink: "/services/invbizres",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن إقامة مستثمر أعمال",
//         detailsType: "span-link"
//       },
//       {
//         id: 17,
//         name: "إقامة مميزة غير محددة المدة ومحددة المدة",
//         className: `${stylePrem.back2} service-item`,
//         detailsLink: "/services/unires",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن إقامة مميز",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 10
//   {
//     id: 10,
//     services: [
//       {
//         id: 18,
//         name: "إقامة رائدة أعمال",
//         className: `${stylePrem.back3} service-item`,
//         detailsLink: "/services/entres",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. استفسار عن إقامة رائد اعمال",
//         detailsType: "span-link"
//       },
//       {
//         id: 19,
//         name: "إقامة مالك عقار",
//         className: `${stylePrem.back4} service-item`,
//         detailsLink: "/services/proownres",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. استفسار عن إقامة مالك عقار",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 11
//   {
//     id: 11,
//     services: [
//       {
//         id: 20,
//         name: "إقامة الموهبة",
//         className: `${stylePrem.back5} service-item`,
//         detailsLink: "/services/talres",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. استفسار عن إقامة الموهبة",
//         detailsType: "span-link"
//       },
//       {
//         id: 21,
//         name: "إقامة الكفائة الاستثنائية",
//         className: `${stylePrem.back6} service-item`,
//         detailsLink: "/services/excepres",
//         whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن إقامة الكفائة الاستثنائية",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 12 - التسويق
//   {
//     id: 12,
//     services: [
//       {
//         id: 22,
//         name: "إدراة وتنظيم الحفلات والمؤتمرات",
//         className: `${styleMark.back1} service-item`,
//         detailsLink: "/services/manorgevCon",
//         whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تنظيم حفلات و مؤتمرات",
//         detailsType: "span-link"
//       },
//       {
//         id: 23,
//         name: "تفعيل تابي وتمارا",
//         className: `${styleMark.back2} service-item`,
//         detailsLink: "/services/actTabtam",
//         whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تفعيل تابي وتمارا",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 13
//   {
//     id: 13,
//     services: [
//       {
//         id: 24,
//         name: "تطوير صفحات الويب",
//         className: `${styleMark.back3} service-item`,
//         detailsLink: "/services/devweb",
//         whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تطوير صفحات الويب",
//         detailsType: "span-link"
//       },
//       {
//         id: 25,
//         name: "رفع جوجل ماب",
//         className: `${styleMark.back4} service-item`,
//         detailsLink: "/services/upmap",
//         whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن رفع جوجل ماب",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 14
//   {
//     id: 14,
//     services: [
//       {
//         id: 26,
//         name: "رفع العلامات التجارية",
//         className: `${styleMark.back5} service-item`,
//         detailsLink: "/services/raibra",
//         whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن رفع العلامة التجارية",
//         detailsType: "span-link"
//       },
//       {
//         id: 27,
//         name: "إدارة وتنظيم المتاجر الالكترونية",
//         className: `${styleMark.back6} service-item`,
//         detailsLink: "/services/manorgEst",
//         whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم اريد استفسر عن إدارة المتاجر الالكترونية",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 15
//   {
//     id: 15,
//     services: [
//       {
//         id: 28,
//         name: "إدارة حسابات السوشيال ميديا",
//         className: `${styleMark.back7} service-item`,
//         detailsLink: "/services/mansocacc",
//         whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن إدارة حسابات السوشيال ميديا",
//         detailsType: "span-link"
//       },
//       {
//         id: 29,
//         name: "تصوير المنتجات",
//         className: `${styleMark.back8} service-item`,
//         detailsLink: "/services/propho",
//         whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تصوير المنتجات",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 16 - المحاسبة
//   {
//     id: 16,
//     services: [
//       {
//         id: 30,
//         name: "مسك الدفاتر المحاسبية",
//         className: `${styleAcc.back1} service-item`,
//         detailsLink: "/services/booAccrec",
//         whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. عندي استفسار عن الدفاتر المحاسبية",
//         detailsType: "span-link"
//       },
//       {
//         id: 31,
//         name: "التهيئة والتدريب على الأنظمة المحاسبية",
//         className: `${styleAcc.back2} service-item`,
//         detailsLink: "/services/settraacc",
//         whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. عندي استفسار عن التدريب على الانظمة المحاسبية",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 17
//   {
//     id: 17,
//     services: [
//       {
//         id: 32,
//         name: "فحص اداء الأنظمة المحاسبية",
//         className: `${styleAcc.back3} service-item`,
//         detailsLink: "/services/accsysper",
//         whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن فحص اداء الانظمة  المحاسبية",
//         detailsType: "span-link"
//       },
//       {
//         id: 33,
//         name: "إدارة المخازن والجرد",
//         className: `${styleAcc.back4} service-item`,
//         detailsLink: "/services/warinvman",
//         whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن إدارة المخازن والجرد",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 18
//   {
//     id: 18,
//     services: [
//       {
//         id: 34,
//         name: "تقديم إستشارات محاسبية",
//         className: `${styleAcc.back5} service-item`,
//         detailsLink: "/services/proacccon",
//         whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. اريد استشارة محاسبية",
//         detailsType: "span-link"
//       },
//       {
//         id: 35,
//         name: "تزويد المنشأة بالانظمة المحاسبية بما يتناسب مع احتياجات النشاط",
//         className: `${styleAcc.back6} service-item`,
//         detailsLink: "/services/proaccsys",
//         whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. اريد نظام محاسبي",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 19
//   {
//     id: 19,
//     services: [
//       {
//         id: 36,
//         name: "إعداد القرارات الضريبية",
//         className: `${styleAcc.back7} service-item`,
//         detailsLink: "/services/pretaxdec",
//         whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن إعداد القرارات الضريبية",
//         detailsType: "span-link"
//       },
//       {
//         id: 37,
//         name: "إعداد التقارير المالية والإدارية والختامية",
//         className: `${styleAcc.back8} service-item`,
//         detailsLink: "/services/prefinadmfin",
//         whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن إعداد التقارير المالية والادارية",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 20 - البرمجة
//   {
//     id: 20,
//     services: [
//       {
//         id: 38,
//         name: "تطبيقات",
//         className: `${styleProg.back1} service-item`,
//         detailsLink: "/services/appDev",
//         whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. عندي استفسار في مجال التطبيقات",
//         detailsType: "span-link"
//       },
//       {
//         id: 39,
//         name: "مواقع الكترونية",
//         className: `${styleProg.back2} service-item`,
//         detailsLink: "/services/web",
//         whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. عندي استفسار في مجال المواقع الالكترونية",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 21
//   {
//     id: 21,
//     services: [
//       {
//         id: 40,
//         name: "الدعم الفني",
//         className: `${styleProg.back3} service-item`,
//         detailsLink: "/services/technicSupport",
//         whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. اريد دعم فني",
//         detailsType: "span-link"
//       },
//       {
//         id: 41,
//         name: "نظام الموارد البشرية",
//         className: `${styleProg.back4} service-item`,
//         detailsLink: "/services/hr",
//         whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. اريد استفسر عن نظام الموارد البشرية",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 22
//   {
//     id: 22,
//     services: [
//       {
//         id: 42,
//         name: "نظام المحاسبة",
//         className: `${styleProg.back5} service-item`,
//         detailsLink: "/services/accountSys",
//         whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. عندي استفسار في النظام المحاسبي",
//         detailsType: "span-link"
//       },
//       {
//         id: 43,
//         name: "نظام إداري",
//         className: `${styleProg.back6} service-item`,
//         detailsLink: "/services/AdminSystem",
//         whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. اريد استفسر في النظام الاداري",
//         detailsType: "span-link"
//       }
//     ]
//   },
//   // المجموعة 23 (خدمة واحدة فقط)
//   {
//     id: 23,
//     services: [
//       {
//         id: 44,
//         name: "نظام CRM",
//         className: `${styleProg.back7} service-item`,
//         detailsLink: "/services/crm",
//         whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. اريد استفسر عن نظام ال crm",
//         detailsType: "span-link"
//       }
//     ]
//   }
// ];



// data/servicesData.js
import styleCompanys from '../css/backgrounds/comCreated.module.css';
import stylePrem from '../css/backgrounds/primResidency.module.css';
import styleMark from '../css/backgrounds/markService.module.css';
import styleAcc from '../css/backgrounds/accServices.module.css';
import styleProg from '../css/backgrounds/programming.module.css';
import styleTrademarks from '../css/backgrounds/trademarks.module.css';

export const servicesData = [
  // المجموعة 1
  {
    id: 1,
    services: [
      {
        id: 0,
        name: "خدمة التدريب والتأهيل",
        className: "training",
        detailsLink: "/services/TrainQualif",
        whatsappLink: "https://wa.me/+966561103887?text= السلام عليكم. اريد استفسر عن خدمة التدريب والتاهيل",
        detailsType: "link" // link أو text
      },
      {
        id: 1,
        name: "خدمات الاستشارات الهندسية",
        className: "eng-consultation",
        detailsLink: "/services",
        whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم. اريد استفسر عن خدمة هندسية",
        detailsType: "link"
      }
    ]
  },
  // المجموعة 2
  {
    id: 2,
    services: [
      {
        id: 2,
        name: "خدمات التأمين الصحي الشامل",
        className: "health-Insurance",
        detailsLink: "/services/medicalservices",
        whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم. عندس استفسار عن خدمات التامين الصحي الشامل",
        detailsType: "span-link"
      },
      {
        id: 3,
        name: "خدمات سابر",
        className: "saber-service",
        detailsLink: "/services/saberservices",
        whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم. عندس استفسار عن خدمات سابر",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 3
  {
    id: 3,
    services: [
      {
        id: 4,
        name: "خدمات وزارة الداخلية",
        className: "ministry-interior",
        detailsLink: "#",
        whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم. اريد استفسر عن خدمات وازارة الداخلية",
        detailsType: "span-text",
        detailsText: "التفاصيل"
      },
      {
        id: 5,
        name: "خدمات منصة ناجز",
        className: "najiz-service",
        detailsLink: "/services/najizServices",
        whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم. اريد استفسر عن خدمات منصة ناجز",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 4
  {
    id: 4,
    services: [
      {
        id: 6,
        name: "خدمات منصة مدد",
        className: "madad-service",
        detailsLink: "/services/madad",
        whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم اريد استفسر عن خدمات منصة مدد",
        detailsType: "span-link"
      },
      {
        id: 7,
        name: "خدمات الدفاع المدني",
        className: "civil-defense",
        detailsLink: "/services/civilservices",
        whatsappLink: "https://wa.me/+966561103887?text=السلام عليكم. لدي استفسار عن خدمات الدفاع المدني",
        detailsType: "span-link",
        detailsText: "التفاصل"
      }
    ]
  },
  // المجموعة 5 - التراخيص
  {
    id: 5,
    services: [
      {
        id: 8,
        name: "الترخيص المهني",
        className: `${styleCompanys.back1} service-item`,
        detailsLink: "/services/professionallicense",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص مهني",
        detailsType: "span-link"
      },
      {
        id: 9,
        name: "الترخيص الزراعي",
        className: `${styleCompanys.back2} service-item`,
        detailsLink: "/services/agriculturallicense",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص زراعي",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 6
  {
    id: 6,
    services: [
      {
        id: 10,
        name: "ترخيص تجاري اجنبي",
        className: `${styleCompanys.back3} service-item`,
        detailsLink: "/services/forecommlice",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص تجاري اجنبي",
        detailsType: "span-link"
      },
      {
        id: 11,
        name: "ترخيص تجاري بشريك سعودي",
        className: `${styleCompanys.back4} service-item`,
        detailsLink: "/services/coiLissauPar",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص تجاري بشريك سعودي",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 7
  {
    id: 7,
    services: [
      {
        id: 12,
        name: "الترخيص المهني بشريك سعودي",
        className: `${styleCompanys.back5} service-item`,
        detailsLink: "/services/proflicesapartner",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص مهني بشريك سعودي",
        detailsType: "span-link"
      },
      {
        id: 13,
        name: "ترخيص أنشطة النقل",
        className: `${styleCompanys.back6} service-item`,
        detailsLink: "/services/transactivlice",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص نشاط نقل",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 8
  {
    id: 8,
    services: [
      {
        id: 14,
        name: "الترخيص العقاري",
        className: `${styleCompanys.back7} service-item`,
        detailsLink: "/services/prolic",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص عقاري",
        detailsType: "span-link"
      },
      {
        id: 15,
        name: "ترخيص صناعي",
        className: `${styleCompanys.back8} service-item`,
        detailsLink: "/services/indlic",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن ترخيص صناعي",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 9 - الإقامات
  {
    id: 9,
    services: [
      {
        id: 16,
        name: "إقامة مستثمر أعمال",
        className: `${stylePrem.back1} service-item`,
        detailsLink: "/services/invbizres",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن إقامة مستثمر أعمال",
        detailsType: "span-link"
      },
      {
        id: 17,
        name: "إقامة مميزة غير محددة المدة ومحددة المدة",
        className: `${stylePrem.back2} service-item`,
        detailsLink: "/services/unires",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن إقامة مميز",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 10
  {
    id: 10,
    services: [
      {
        id: 18,
        name: "إقامة رائدة أعمال",
        className: `${stylePrem.back3} service-item`,
        detailsLink: "/services/entres",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. استفسار عن إقامة رائد اعمال",
        detailsType: "span-link"
      },
      {
        id: 19,
        name: "إقامة مالك عقار",
        className: `${stylePrem.back4} service-item`,
        detailsLink: "/services/proownres",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. استفسار عن إقامة مالك عقار",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 11
  {
    id: 11,
    services: [
      {
        id: 20,
        name: "إقامة الموهبة",
        className: `${stylePrem.back5} service-item`,
        detailsLink: "/services/talres",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. استفسار عن إقامة الموهبة",
        detailsType: "span-link"
      },
      {
        id: 21,
        name: "إقامة الكفائة الاستثنائية",
        className: `${stylePrem.back6} service-item`,
        detailsLink: "/services/excepres",
        whatsappLink: "https://wa.me/+966509150333?text=السلام عليكم. اريد استفسر عن إقامة الكفائة الاستثنائية",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 12 - التسويق
  {
    id: 12,
    services: [
      {
        id: 22,
        name: "إدراة وتنظيم الحفلات والمؤتمرات",
        className: `${styleMark.back1} service-item`,
        detailsLink: "/services/manorgevCon",
        whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تنظيم حفلات و مؤتمرات",
        detailsType: "span-link"
      },
      {
        id: 23,
        name: "تفعيل تابي وتمارا",
        className: `${styleMark.back2} service-item`,
        detailsLink: "/services/actTabtam",
        whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تفعيل تابي وتمارا",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 13
  {
    id: 13,
    services: [
      {
        id: 24,
        name: "تطوير صفحات الويب",
        className: `${styleMark.back3} service-item`,
        detailsLink: "/services/devweb",
        whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تطوير صفحات الويب",
        detailsType: "span-link"
      },
      {
        id: 25,
        name: "رفع جوجل ماب",
        className: `${styleMark.back4} service-item`,
        detailsLink: "/services/upmap",
        whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن رفع جوجل ماب",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 14
  {
    id: 14,
    services: [
      {
        id: 26,
        name: "رفع العلامات التجارية",
        className: `${styleMark.back5} service-item`,
        detailsLink: "/services/raibra",
        whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن رفع العلامة التجارية",
        detailsType: "span-link"
      },
      {
        id: 27,
        name: "إدارة وتنظيم المتاجر الالكترونية",
        className: `${styleMark.back6} service-item`,
        detailsLink: "/services/manorgEst",
        whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم اريد استفسر عن إدارة المتاجر الالكترونية",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 15
  {
    id: 15,
    services: [
      {
        id: 28,
        name: "إدارة حسابات السوشيال ميديا",
        className: `${styleMark.back7} service-item`,
        detailsLink: "/services/mansocacc",
        whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن إدارة حسابات السوشيال ميديا",
        detailsType: "span-link"
      },
      {
        id: 29,
        name: "تصوير المنتجات",
        className: `${styleMark.back8} service-item`,
        detailsLink: "/services/propho",
        whatsappLink: "https://wa.me/+966531906999?text=السلام عليكم. اريد استفسر عن تصوير المنتجات",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 16 - المحاسبة
  {
    id: 16,
    services: [
      {
        id: 30,
        name: "مسك الدفاتر المحاسبية",
        className: `${styleAcc.back1} service-item`,
        detailsLink: "/services/booAccrec",
        whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. عندي استفسار عن الدفاتر المحاسبية",
        detailsType: "span-link"
      },
      {
        id: 31,
        name: "التهيئة والتدريب على الأنظمة المحاسبية",
        className: `${styleAcc.back2} service-item`,
        detailsLink: "/services/settraacc",
        whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. عندي استفسار عن التدريب على الانظمة المحاسبية",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 17
  {
    id: 17,
    services: [
      {
        id: 32,
        name: "فحص اداء الأنظمة المحاسبية",
        className: `${styleAcc.back3} service-item`,
        detailsLink: "/services/accsysper",
        whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن فحص اداء الانظمة  المحاسبية",
        detailsType: "span-link"
      },
      {
        id: 33,
        name: "إدارة المخازن والجرد",
        className: `${styleAcc.back4} service-item`,
        detailsLink: "/services/warinvman",
        whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن إدارة المخازن والجرد",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 18
  {
    id: 18,
    services: [
      {
        id: 34,
        name: "تقديم إستشارات محاسبية",
        className: `${styleAcc.back5} service-item`,
        detailsLink: "/services/proacccon",
        whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. اريد استشارة محاسبية",
        detailsType: "span-link"
      },
      {
        id: 35,
        name: "تزويد المنشأة بالانظمة المحاسبية بما يتناسب مع احتياجات النشاط",
        className: `${styleAcc.back6} service-item`,
        detailsLink: "/services/proaccsys",
        whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. اريد نظام محاسبي",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 19
  {
    id: 19,
    services: [
      {
        id: 36,
        name: "إعداد القرارات الضريبية",
        className: `${styleAcc.back7} service-item`,
        detailsLink: "/services/pretaxdec",
        whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن إعداد القرارات الضريبية",
        detailsType: "span-link"
      },
      {
        id: 37,
        name: "إعداد التقارير المالية والإدارية والختامية",
        className: `${styleAcc.back8} service-item`,
        detailsLink: "/services/prefinadmfin",
        whatsappLink: "https://wa.me/+966564716444?text=السلام عليكم. اريد استفسر عن إعداد التقارير المالية والادارية",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 20 - البرمجة
  {
    id: 20,
    services: [
      {
        id: 38,
        name: "تطبيقات",
        className: `${styleProg.back1} service-item`,
        detailsLink: "/services/appDev",
        whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. عندي استفسار في مجال التطبيقات",
        detailsType: "span-link"
      },
      {
        id: 39,
        name: "مواقع الكترونية",
        className: `${styleProg.back2} service-item`,
        detailsLink: "/services/web",
        whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. عندي استفسار في مجال المواقع الالكترونية",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 21
  {
    id: 21,
    services: [
      {
        id: 40,
        name: "الدعم الفني",
        className: `${styleProg.back3} service-item`,
        detailsLink: "/services/technicSupport",
        whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. اريد دعم فني",
        detailsType: "span-link"
      },
      {
        id: 41,
        name: "نظام الموارد البشرية",
        className: `${styleProg.back4} service-item`,
        detailsLink: "/services/hr",
        whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. اريد استفسر عن نظام الموارد البشرية",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 22
  {
    id: 22,
    services: [
      {
        id: 42,
        name: "نظام المحاسبة",
        className: `${styleProg.back5} service-item`,
        detailsLink: "/services/accountSys",
        whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. عندي استفسار في النظام المحاسبي",
        detailsType: "span-link"
      },
      {
        id: 43,
        name: "نظام إداري",
        className: `${styleProg.back6} service-item`,
        detailsLink: "/services/AdminSystem",
        whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. اريد استفسر في النظام الاداري",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 23
  {
    id: 23,
    services: [
      {
        id: 44,
        name: "نظام CRM",
        className: `${styleProg.back7} service-item`,
        detailsLink: "/services/crm",
        whatsappLink: "https://wa.me/+966554069111?text=السلام عليكم. اريد استفسر عن نظام ال crm",
        detailsType: "span-link"
      },
      {
        id: 45,
        name: "العلامات التجارية",
        className: `${styleTrademarks.back1} service-item`,
        detailsLink: "/services/trademarks",
        whatsappLink: "https://wa.me/+966540062640?text=السلام عليكم. عندي استفسار بخصوص العلامات التجارية",
        detailsType: "span-link"
      },
    ]
  },
  // المجموعة 24 - الملكية الفكرية (الخدمات المضافة)
  {
    id: 24,
    services: [
      {
        id: 46,
        name: "تسجيل براءة اختراع",
        className: `${styleTrademarks.back2} service-item`,
        detailsLink: "/services/patent",
        whatsappLink: "https://wa.me/+966540062640?text=السلام عليكم. عندي استفسار في تسجيل براءة الاختراع",
        detailsType: "span-link"
      },
      {
        id: 47,
        name: "تسجيل منتج صناعي",
        className: `${styleTrademarks.back3} service-item`,
        detailsLink: "/services/indusproduct",
        whatsappLink: "https://wa.me/+966540062640?text=السلام عليكم. اريد اسئل عند تسجيل منتج صناعي",
        detailsType: "span-link"
      }
    ]
  },
  // المجموعة 25 - الملكية الفكرية
  {
    id: 25,
    services: [
      {
        id: 48,
        name: "تسجيل حقوق نشر",
        className: `${styleTrademarks.back4} service-item`,
        detailsLink: "/services/copyright",
        whatsappLink: "https://wa.me/+966540062640?text=السلام عليكم. اريد استفسر عن تسجيل حقوق النشر",
        detailsType: "span-link"
      }
    ]
  }
];